<template>
  <!--.....黑名单的提示.....-->
  <div class="blacklist">
    <el-dialog title="确定要加入黑名单吗？" :visible.sync="visible" center>
      <div class="">加入黑名单后，你们不能彼此的互动将受到限制：
        <p>.互相取消关注</p>
        <p>.互相看不到对方状态</p>
<!--        <p>.互相不能评论，点赞，打赏对方的动态</p>-->
        <p>.互相不能发消息，打招呼</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="addBlackList">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { post } from '@/assets/js/json'

  export default {
    props: {
      user: {
        type: Object,
        default: null
      },
      uid: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        visible: false
      }
    },
    methods: {
      close () {
        this.visible = false
      },
      open () {
        this.visible = true
      },
      addBlackList () {
        const option = {
          'targetId': this.user.id
        }
        post('/api/member/blacklist/add', option).then((res) => {
          if (res.data.success) {
            if (this.user) {
              this.user.blacklist = true
            }
            if (this.func) {
              this.func()
            }
            this.$tips('已将对方加入黑名单')
          }
        })
        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  /*.....隐藏的黑名单......*/


</style>



// WEBPACK FOOTER //
// src/components/tools/addBlackList.vue